import { createSelector } from 'reselect';
import assign from 'lodash/assign';

const selectEditor = state => state.editor;

// Select an item from 'props'.
const selectItem = (_, item) => item;

// The updatedItems object only exist if an editor is loaded.
const selectUpdatedItems = state => selectEditor(state).updatedItems || {};

export const selectItemUpdates = createSelector(
  [selectUpdatedItems, selectItem],
  (updatedItems, item) => {

    let itemKey = item.id || item.name;
    if (!itemKey && (typeof item === String || typeof item === Number)) {
      itemKey = item;
    }

    return assign({}, item, (itemKey && updatedItems[itemKey]) || {});
  }
);

